module.exports = __webpack_public_path__ + "static/media/recent-03.a9876ffb.jpg";